/* ELYA — boutons animés, ouverture animée des fiches et description éditoriale */
(function () {
  var calm = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Onde au clic sur les boutons du site
  var BTN = '.button,.add-to-cart-button,.ps-tabs button,.spot,.ps-color';
  document.addEventListener('pointerdown', function (e) {
    var b = e.target.closest(BTN);
    if (!b || calm) return;
    if (getComputedStyle(b).position === 'static') b.style.position = 'relative';
    b.style.overflow = 'hidden';
    b.classList.add('elya-press');
    var r = b.getBoundingClientRect(), d = Math.max(r.width, r.height) * 2.2, s = document.createElement('span');
    s.className = 'elya-ripple';
    s.style.cssText = 'width:' + d + 'px;height:' + d + 'px;left:' + (e.clientX - r.left - d / 2) + 'px;top:' + (e.clientY - r.top - d / 2) + 'px';
    b.appendChild(s);
    setTimeout(function () { s.remove(); }, 700);
  });

  // Carte produit → fiche : la photo s'agrandit, puis la fiche s'ouvre
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.product-card a[href*="/products/"]');
    if (!a || calm || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    var card = a.closest('.product-card'), im = card && card.querySelector('img');
    if (!im || e.target.closest('button,input,select,label,[role=button]')) return;
    e.preventDefault();
    var r = im.getBoundingClientRect(), c = im.cloneNode(), v = document.createElement('div');
    card.classList.add('going');
    v.className = 'flip-veil';
    c.className = 'flip-img';
    c.removeAttribute('loading');
    c.removeAttribute('sizes');
    c.style.cssText = 'left:' + r.left + 'px;top:' + r.top + 'px;width:' + r.width + 'px;height:' + r.height + 'px';
    document.body.appendChild(v);
    document.body.appendChild(c);
    c.getBoundingClientRect();
    setTimeout(function () {
      var m = innerWidth < 860, w = Math.min(innerWidth * 0.5, innerHeight * 0.75 * 0.75);
      c.style.cssText = 'left:' + (m ? 0 : innerWidth * 0.05) + 'px;top:' + (m ? 60 : 110) + 'px;width:' + (m ? innerWidth : w) + 'px;height:' + (m ? innerWidth * 1.25 : w * 4 / 3) + 'px';
      v.classList.add('on');
    }, 20);
    setTimeout(function () { location.href = a.href; }, 620);
  });
  addEventListener('pageshow', function () {
    document.querySelectorAll('.flip-img,.flip-veil').forEach(function (x) { x.remove(); });
    document.querySelectorAll('.product-card.going').forEach(function (x) { x.classList.remove('going'); });
  });

  // Description éditoriale
  function initStory(ps) {
    if (!ps || ps.dataset.ready) return;
    ps.dataset.ready = '1';
    var n = 0;
    ps.querySelectorAll('.ps-title .w>*').forEach(function (w) { w.style.setProperty('--i', n++); });

    function count(el) {
      var raw = el.getAttribute('data-count'), to = parseInt(raw, 10);
      if (isNaN(to) || String(to) !== raw || calm) return;
      var t0 = null;
      el.textContent = '0';
      function step(t) {
        if (!t0) t0 = t;
        var k = Math.min((t - t0) / 1600, 1);
        el.textContent = Math.round(to * (1 - Math.pow(1 - k, 4)));
        if (k < 1) requestAnimationFrame(step);
      }
      setTimeout(function () { requestAnimationFrame(step); }, el.closest('.ps-badge') ? 1100 : 200);
    }
    var go = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (!x.isIntersecting) return;
        x.target.classList.add('go');
        x.target.querySelectorAll('[data-count]').forEach(count);
        go.unobserve(x.target);
      });
    }, { threshold: 0.2 });
    ps.querySelectorAll('.ps-hero,.ps-board,.ps-figs,.ps-fabric,.ps-looks,.eh-story,.eh-trust,.eh-social,.eh-blog').forEach(function (x) { go.observe(x); });

    var par = ps.querySelector('[data-parallax]');
    if (par && !calm) {
      var pim = par.querySelector('img');
      addEventListener('scroll', function () {
        requestAnimationFrame(function () {
          var r = par.getBoundingClientRect(), k = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
          pim.style.setProperty('--py', (-8 + k * 10).toFixed(2) + '%');
        });
      }, { passive: true });
    }

    var board = ps.querySelector('.ps-board');
    if (board) {
      var tabs = board.querySelectorAll('[data-mode-btn]'), ink = board.querySelector('.ps-tab-ink');
      var spots = ps.querySelectorAll('.spot[data-spot]'), items = ps.querySelectorAll('.ps-list li[data-spot]'), cur = 0, auto = null;
      var tips = ps.querySelectorAll('.ps-tip[data-tip]'), bubbles = tips.length > 0;
      var setInk = function (b) { if (b) { ink.style.width = b.offsetWidth + 'px'; ink.style.transform = 'translateX(' + b.offsetLeft + 'px)'; } };
      var stopAuto = function () { clearInterval(auto); auto = null; };
      var show = function (i) {
        cur = i;
        spots.forEach(function (s) {
          var on = +s.getAttribute('data-spot') === i;
          s.classList.toggle('on', on);
          if (bubbles) s.setAttribute('aria-expanded', on);
        });
        items.forEach(function (s) { s.classList.toggle('on', +s.getAttribute('data-spot') === i); });
        tips.forEach(function (t) { t.classList.toggle('on', +t.getAttribute('data-tip') === i); });
      };
      // Mode bulles : un clic ouvre la bulle du numéro, un second clic, un clic à côté ou Échap la ferment
      var toggle = function (i) { show(bubbles && cur === i && ps.querySelector('.ps-tip.on') ? -1 : i); };
      tabs.forEach(function (b) {
        b.addEventListener('click', function () {
          board.setAttribute('data-mode', b.getAttribute('data-mode-btn'));
          tabs.forEach(function (o) { o.setAttribute('aria-selected', o === b); });
          setInk(b);
          stopAuto();
          if (bubbles) show(-1);
        });
      });
      setInk(tabs[0]);
      addEventListener('resize', function () { setInk(board.querySelector('[aria-selected=true]')); });
      spots.forEach(function (s) {
        var i = +s.getAttribute('data-spot');
        s.addEventListener('click', function (e) { e.stopPropagation(); stopAuto(); toggle(i); });
        if (!bubbles) s.addEventListener('mouseenter', function () { stopAuto(); show(i); });
      });
      items.forEach(function (s) {
        s.addEventListener('click', function (e) {
          e.stopPropagation();
          stopAuto();
          if (board.getAttribute('data-mode') !== 'spots') tabs[0].click();
          toggle(+s.getAttribute('data-spot'));
        });
      });
      if (bubbles) {
        tips.forEach(function (t) {
          t.addEventListener('click', function (e) { e.stopPropagation(); });
          t.querySelector('.ps-tip-x').addEventListener('click', function () { show(-1); });
        });
        document.addEventListener('click', function () { if (ps.querySelector('.ps-tip.on')) show(-1); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') show(-1); });
        show(-1);
      } else if (spots.length) show(0);
      if (!bubbles && !calm && spots.length > 1) {
        new IntersectionObserver(function (en, o) {
          if (en[0].isIntersecting) { o.disconnect(); auto = setInterval(function () { show((cur + 1) % spots.length); }, 3200); }
        }, { threshold: 0.5 }).observe(board);
      }
    }

    ps.querySelectorAll('[data-top]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); scrollTo({ top: 0, behavior: calm ? 'auto' : 'smooth' }); });
    });
  }
  function initAll() { document.querySelectorAll('.ps').forEach(initStory); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

/* Accueil et collections façon démo : carrousels, vidéos, apparitions, boutons, cartes */
(function () {
  var calm = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setupRail(rail) {
    var ui = rail.parentNode.querySelector('.e-rail-ui');
    var items = [].slice.call(rail.children);
    if (!items.length) return;
    var dots = ui ? ui.querySelector('.e-dots') : null;
    var prev = ui ? ui.querySelector('[data-prev]') : null, next = ui ? ui.querySelector('[data-next]') : null;
    function pages() {
      var visible = Math.max(1, Math.round(rail.clientWidth / (items[0].getBoundingClientRect().width || 1)));
      return Math.max(1, items.length - visible + 1);
    }
    function current() {
      var w = items[0].getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 0);
      return Math.round(rail.scrollLeft / (w || 1));
    }
    function update() {
      var c = Math.min(current(), pages() - 1);
      if (dots) [].forEach.call(dots.children, function (d, i) { d.classList.toggle('e-on', i === c); });
      if (prev) prev.disabled = rail.scrollLeft < 4;
      if (next) next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
    }
    function build() {
      if (!dots) return;
      var n = pages();
      dots.innerHTML = '';
      ui.classList.toggle('e-hidden', n < 2);
      for (var i = 0; i < n; i++) {
        var d = document.createElement('button');
        d.type = 'button';
        d.setAttribute('aria-label', 'Aller à la diapositive ' + (i + 1));
        (function (k) { d.addEventListener('click', function () { rail.scrollTo({ left: items[k].offsetLeft - items[0].offsetLeft, behavior: calm ? 'auto' : 'smooth' }); }); })(i);
        dots.appendChild(d);
      }
      update();
    }
    var step = function (dir) { rail.scrollBy({ left: dir * rail.clientWidth * 0.9, behavior: calm ? 'auto' : 'smooth' }); };
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    rail.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    addEventListener('resize', build);
    build();
    if (!calm && matchMedia('(max-width: 1024px)').matches && rail.scrollWidth > rail.clientWidth + 10) {
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return;
        io.disconnect();
        setTimeout(function () { rail.scrollBy({ left: 60, behavior: 'smooth' }); setTimeout(function () { rail.scrollBy({ left: -60, behavior: 'smooth' }); }, 550); }, 500);
      }, { threshold: 0.6 });
      io.observe(rail);
    }
  }

  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    root.querySelectorAll('[data-rail]').forEach(setupRail);

    // Vidéos : lecture seulement quand elles sont visibles
    var vo = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        var v = x.target;
        if (x.isIntersecting && !calm) { var p = v.play(); if (p) p.catch(function () {}); } else v.pause();
      });
    }, { threshold: 0.25 });
    root.querySelectorAll('video').forEach(function (v) { v.muted = true; v.removeAttribute('controls'); vo.observe(v); });

    // Apparitions au défilement
    var sel = '.e-sec-head,.e-tile,.e-split>*,.e-values>div,.e-teaser .e-txt>*,.e-band .e-narrow>*,.e-social-head,.e-feed>a,.e-faq details';
    var els = [].slice.call(root.querySelectorAll(sel));
    els.forEach(function (e) {
      var sib = [].slice.call(e.parentNode.children).filter(function (c) { return c.matches(sel); });
      e.style.setProperty('--d', Math.min(sib.indexOf(e), 6) * 0.08 + 's');
      e.classList.add('e-rv');
    });
    var ro = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('e-in'); ro.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { ro.observe(e); });

    // Boutons : onde au clic
    root.addEventListener('pointerdown', function (e) {
      var b = e.target.closest('.e-btn,.e-soc,.e-arrow');
      if (!b || calm) return;
      var r = b.getBoundingClientRect(), d = Math.max(r.width, r.height) * 2.2, s = document.createElement('span');
      s.className = 'e-ripple';
      s.style.cssText = 'width:' + d + 'px;height:' + d + 'px;left:' + (e.clientX - r.left - d / 2) + 'px;top:' + (e.clientY - r.top - d / 2) + 'px';
      if (getComputedStyle(b).position === 'static') b.style.position = 'relative';
      b.style.overflow = 'hidden';
      b.appendChild(s);
      setTimeout(function () { s.remove(); }, 700);
    });

    // Carte produit : la photo s'agrandit, puis la fiche s'ouvre
    root.addEventListener('click', function (e) {
      var a = e.target.closest('.e-card a');
      if (!a || calm || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      var card = a.closest('.e-card'), im = card.querySelector('.e-ph img');
      if (!im) return;
      e.preventDefault();
      var r = im.getBoundingClientRect(), c = im.cloneNode(), v = document.createElement('div');
      card.classList.add('e-going');
      v.className = 'flip-veil';
      c.className = 'flip-img';
      c.removeAttribute('loading');
      c.removeAttribute('sizes');
      c.style.cssText = 'left:' + r.left + 'px;top:' + r.top + 'px;width:' + r.width + 'px;height:' + r.height + 'px';
      document.body.appendChild(v);
      document.body.appendChild(c);
      c.getBoundingClientRect();
      setTimeout(function () {
        var m = innerWidth < 860, w = Math.min(innerWidth * 0.5, innerHeight * 0.75 * 0.75);
        c.style.cssText = 'left:' + (m ? 0 : innerWidth * 0.05) + 'px;top:' + (m ? 60 : 110) + 'px;width:' + (m ? innerWidth : w) + 'px;height:' + (m ? innerWidth * 1.25 : w * 4 / 3) + 'px';
        v.classList.add('on');
      }, 20);
      setTimeout(function () { location.href = a.href; }, 620);
    });
  }

  function initAll() { document.querySelectorAll('.ea').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
  addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('.ea .e-card.e-going').forEach(function (x) { x.classList.remove('e-going'); });
  });
})();
